import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logo from "../asset/logowhite.png";
import loginbg from "../asset/login/login.png";
import { useNavigate } from "react-router-dom";
import SummaryApi from "../common"; // assuming studentUpdateForgotPassword is here
import { FaEye, FaEyeSlash } from "react-icons/fa";

const StudentResetPassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!newPassword || !confirmPassword) {
      toast.error("Please fill in all fields.");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }

    const email = localStorage.getItem("student_identifier");
    if (!email) {
      toast.error("No verified email found. Please verify OTP first.");
      return;
    }

    try {
      const response = await fetch(SummaryApi.studentUpdateForgotPassword.url, {
        method: SummaryApi.studentUpdateForgotPassword.method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          newPassword,
        }),
      });

      const data = await response.json();

      if (data.status === true) {
        toast.success("Password updated successfully!");
        setTimeout(() => {
          navigate("/student-login"); // or wherever you want to send after password reset
        }, 1500);
      } else {
        toast.error(data.message || "Failed to update password.");
      }
    } catch (error) {
      console.error("Password update error:", error);
      toast.error("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="min-h-screen w-full bg-white flex items-center justify-center">
      <div className="w-full max-w-7xl min-h-[650px] flex rounded-3xl overflow-hidden shadow-lg">
        {/* Left Side - Background with logo */}
        <div className="w-1/2 relative">
          <img
            src={loginbg}
            alt="Instructor Background"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black bg-opacity-30" />
          <div className="relative z-10 flex items-center justify-center h-full">
            <img src={logo} alt="Logo" className="w-64" />
          </div>
        </div>

        {/* Right Side - Password Reset Form */}
        <div className="w-1/2 bg-white flex items-start justify-center pt-12 px-10">
          <div className="w-full max-w-md">
            <h2 className="text-[36px] font-bold text-blue-900 mb-10 text-center font-inter">
              Reset Password
            </h2>

            <form className="space-y-6" onSubmit={handleSubmit}>
              {/* New Password */}
              <div>
                <label
                  htmlFor="newPassword"
                  className="block text-sm font-medium text-gray-700 font-inter mb-1"
                >
                  New Password
                </label>
                <div className="relative">
                  <input
                    id="newPassword"
                    type={showNewPassword ? "text" : "password"}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    className="w-full py-3 px-4 pr-12 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 outline-none text-lg font-inter"
                    placeholder="Enter new password"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowNewPassword(!showNewPassword)}
                    className="absolute inset-y-0 right-3 flex items-center text-gray-500"
                    tabIndex={-1}
                  >
                    {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </div>

              {/* Confirm Password */} 
              <div>
                <label
                  htmlFor="confirmPassword"
                  className="block text-sm font-medium text-gray-700 font-inter mb-1"
                >
                  Confirm Password
                </label>
                <div className="relative">
                  <input
                    id="confirmPassword"
                    type={showConfirmPassword ? "text" : "password"}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    className="w-full py-3 px-4 pr-12 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 outline-none text-lg font-inter"
                    placeholder="Confirm new password"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    className="absolute inset-y-0 right-3 flex items-center text-gray-500"
                    tabIndex={-1}
                  >     
                    {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="w-full py-3 bg-blue-900 hover:bg-blue-800 text-white font-semibold rounded-lg shadow-md transition duration-200 font-inter mt-6"
              >
                RESET PASSWORD
              </button>
            </form>
          </div>
        </div>
      </div>

      <ToastContainer />
    </div>
  );
};

export default StudentResetPassword;
